import PredictedAttendance from "./predicted-attendance";
import AttendancePeak from "./attendance-peak";
import BusiestTime from "./busiest-time";
import AverageVisitDuration from "./average-visit-duration";
import Loader from "components/loader/Loader";
// import { Link } from "react-router-dom";

const AttendanceOverview = ({ dashboardData, selectedCampusId, loading }) => {
  const isNegative = (value) => String(value || "").includes("-");

  const getOccupancyColor = (percentage) => {
    if (percentage <= 50) return "text-green-500"; // Comfortable
    if (percentage <= 85) return "text-yellow-500"; // Moderate
    if (percentage <= 100) return "text-red-500"; // Full
    return "text-red-700"; // Overcapacity
  };

  const getOccupancySvgColor = (percentage) => {
    if (percentage <= 50) return "#22C55E"; // Green (tailwind: green-500)
    if (percentage <= 85) return "#EAB308"; // Yellow (tailwind: yellow-500)
    if (percentage <= 100) return "#EF4444"; // Red (tailwind: red-500)
    return "#B91C1C"; // Darker Red (tailwind: red-700)
  };

  const getOccupancySvg = (percentage) => {
    if (percentage <= 50) return "Comfortable"; // Green (tailwind: green-500)
    if (percentage <= 85) return "Moderate"; // Yellow (tailwind: yellow-500)
    if (percentage <= 100) return "Full"; // Red (tailwind: red-500)
    return "Overcapacity"; // Darker Red (tailwind: red-700)
  };

  return (
    <>
      {loading ? (
        <div className="flex items-center justify-center h-full w-full">
          <Loader />
        </div>
      ) : (
        <>
          <div className="flex flex-wrap gap-4 items-center mt-5">
            {/* <div className="flex-1">
          <div className="flex p-[30px] items-center rounded-[30px] gap-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
            <div className="flex flex-1 with-separator">
              <div className="flex-none mr-4">
                <svg
                  width="56"
                  height="56"
                  viewBox="0 0 56 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="56" height="56" rx="28" fill="#F0FBEC" />
                  <path
                    d="M28 24L32 28M32 28L28 32M32 28H19M19.3378 23C21.0669 20.011 24.2986 18 28 18C33.5228 18 38 22.4772 38 28C38 33.5228 33.5228 38 28 38C24.2986 38 21.0669 35.989 19.3378 33"
                    stroke="#6DA38C"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="flex-1">
                <p className="text-sm text-gray-700">Total Entries</p>
                <p>
                  <span className="text-2xl font-bold mr-2">756</span>
                  <span className="text-[12px] font-bold ml-2 text-green-atrium">
                    +2.45%
                  </span>
                </p>
              </div>
            </div>
            <div className="flex flex-1">
              <div className="flex-none mr-4">
                <svg
                  width="57"
                  height="56"
                  viewBox="0 0 57 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="0.5" width="56" height="56" rx="28" fill="#FFF4F0" />
                  <path
                    d="M34.5 24L38.5 28M38.5 28L34.5 32M38.5 28H25.5M31.5 20.204C30.2252 19.4383 28.7452 19 27.1667 19C22.3802 19 18.5 23.0294 18.5 28C18.5 32.9706 22.3802 37 27.1667 37C28.7452 37 30.2252 36.5617 31.5 35.796"
                    stroke="#EE5D50"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="flex-1">
                <p className="text-sm text-gray-700">Total Exits</p>
                <p>
                  <span className="text-2xl font-bold mr-2">756</span>
                  <span className="arrow-up"></span>
                  <span className="text-[12px] font-bold ml-2 text-green-atrium">
                    +2.45%
                  </span>
                </p>
              </div>
            </div>
            <div className="flex-none p">
              <Link
                to="/admin/dashboard/entries-and-exits"
                className="inline-block rounded-2xl bg-gray-50 dark:!bg-navy-700 p-[12px]"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.1665 10H15.8332M15.8332 10L9.99984 4.16669M15.8332 10L9.99984 15.8334"
                    stroke="#707EAE"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </div> */}
            <div className="flex-1">
              <div className="flex flex-col md:flex-row p-[30px] items-start md:items-center rounded-[30px] gap-[20px] md:gap-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
                {/* Entries Block */}
                <div className="flex flex-1 items-center md:with-separator  md:border-r border-gray-200 pr-4 md:pr-0">
                  <div className="flex-none mr-4">
                    <svg
                      width="56"
                      height="56"
                      viewBox="0 0 56 56"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="56" height="56" rx="28" fill="#F0FBEC" />
                      <path
                        d="M28 24L32 28M32 28L28 32M32 28H19M19.3378 23C21.0669 20.011 24.2986 18 28 18C33.5228 18 38 22.4772 38 28C38 33.5228 33.5228 38 28 38C24.2986 38 21.0669 35.989 19.3378 33"
                        stroke="#6DA38C"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="flex-1">
                    {/* <p className="text-sm text-gray-700">Live Entries Today</p> */}
                    <p className="text-sm text-gray-700">Live Count</p>
                    <p>
                      <span className="text-2xl font-bold mr-2">
                        {dashboardData?.totalInCount || 0}
                      </span>
                      {/* <span
                        className={
                          dashboardData?.inCountChange?.includes("-")
                            ? "arrow-down"
                            : "arrow-up"
                        }
                      ></span> */}
                      <span
                        className={
                          isNegative(dashboardData?.inCountChange)
                            ? "arrow-down"
                            : "arrow-up"
                        }
                      ></span>
                      <span
                        // className={`text-[12px] font-bold ml-2 ${
                        //   dashboardData?.inCountChange?.includes("-")
                        //     ? "text-red-500"
                        //     : "text-green-atrium"
                        // }`}
                        className={`text-[12px] font-bold ml-2 ${
                          isNegative(dashboardData?.inCountChange)
                            ? "text-red-500"
                            : "text-green-atrium"
                        }`}
                      >
                        {dashboardData?.inCountChange || "0"} %
                      </span>
                    </p>
                  </div>
                </div>

                {/* Exits Block */}
                <div className="flex flex-1 items-center">
                  <div className="flex-none mr-4">
                    <svg
                      width="57"
                      height="56"
                      viewBox="0 0 57 56"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.5"
                        width="56"
                        height="56"
                        rx="28"
                        fill="#FFF4F0"
                      />
                      <path
                        d="M34.5 24L38.5 28M38.5 28L34.5 32M38.5 28H25.5M31.5 20.204C30.2252 19.4383 28.7452 19 27.1667 19C22.3802 19 18.5 23.0294 18.5 28C18.5 32.9706 22.3802 37 27.1667 37C28.7452 37 30.2252 36.5617 31.5 35.796"
                        stroke="#EE5D50"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="flex-1">
                    {/* <p className="text-sm text-gray-700">Live Exits Today</p> */}
                    <p className="text-sm text-gray-700">
                      Total Visitors (Day)
                    </p>
                    <p>
                      <span className="text-2xl font-bold mr-2">
                        {dashboardData?.totalVisitors || 0}
                      </span>
                      <span
                        // className={
                        //   dashboardData?.outCountChange?.includes("-")
                        //     ? "arrow-down"
                        //     : "arrow-up"
                        // }
                        className={
                          isNegative(dashboardData?.totalVisitorsChange)
                            ? "arrow-down"
                            : "arrow-up"
                        }
                      ></span>
                      <span
                        // className={`text-[12px] font-bold ml-2 ${
                        //   dashboardData?.outCountChange?.includes("-")
                        //     ? "text-red-500"
                        //     : "text-green-atrium"
                        // }`}
                        className={`text-[12px] font-bold ml-2 ${
                          isNegative(dashboardData?.totalVisitorsChange)
                            ? "text-red-500"
                            : "text-green-atrium"
                        }`}
                      >
                        {dashboardData?.totalVisitorsChange || "0"} %
                      </span>
                    </p>
                  </div>
                </div>

                {/* Arrow Link */}
                {/* <div className="flex-none self-end md:self-center absolute md:relative">
              <Link
                to="/admin/dashboard/entries-and-exits"
                className="inline-block rounded-2xl bg-gray-50 dark:!bg-navy-700 p-[12px]"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.1665 10H15.8332M15.8332 10L9.99984 4.16669M15.8332 10L9.99984 15.8334"
                    stroke="#707EAE"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            </div> */}
              </div>
            </div>

            <div className="flex gap-4 flex-1">
              <div className="flex flex-1 items-center rounded-[30px] p-[30px] gap-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
                <div className="flex-1">
                  <p className="text-sm text-gray-700">
                    Occupancy ratio {""}
                    <span
                      className={`${getOccupancyColor(
                        dashboardData?.occupancyPercentage || 0
                      )}`}
                    >
                      (
                      {getOccupancySvg(dashboardData?.occupancyPercentage || 0)}
                      )
                    </span>
                  </p>

                  <p>
                    <span className="mr-2 inline-block h-full align-bottom">
                      {dashboardData?.occupancyPercentage > 85 && (
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          {/* <path
                          d="M10.5662 3.0893C11.2034 2.02264 12.7966 2.02264 13.4338 3.08931L22.2757 17.8893C22.913 18.956 22.1164 20.2893 20.8419 20.2893H3.1581C1.88359 20.2893 1.08703 18.956 1.72428 17.8893L10.5662 3.0893Z"
                          fill="#EE5D50"
                        /> */}
                          <path
                            d="M10.5662 3.0893C11.2034 2.02264 12.7966 2.02264 13.4338 3.08931L22.2757 17.8893C22.913 18.956 22.1164 20.2893 20.8419 20.2893H3.1581C1.88359 20.2893 1.08703 18.956 1.72428 17.8893L10.5662 3.0893Z"
                            fill={getOccupancySvgColor(
                              dashboardData?.occupancyPercentage || 0
                            )}
                          />
                          <path
                            d="M10.9699 14.3404L10.6988 6.28931H13.3193L13.0301 14.3404H10.9699ZM12.0181 18.2893C11.5602 18.2893 11.1928 18.1645 10.9157 17.9148C10.6386 17.6538 10.5 17.3361 10.5 16.9616C10.5 16.5872 10.6386 16.2751 10.9157 16.0255C11.1928 15.7645 11.5602 15.634 12.0181 15.634C12.4518 15.634 12.8072 15.7645 13.0843 16.0255C13.3614 16.2751 13.5 16.5872 13.5 16.9616C13.5 17.3361 13.3614 17.6538 13.0843 17.9148C12.8072 18.1645 12.4518 18.2893 12.0181 18.2893Z"
                            fill="white"
                          />
                        </svg>
                      )}
                    </span>
                    {/* <span className="text-2xl font-bold mr-2">
                      {dashboardData?.occupancyPercentage || "0"}
                    </span> */}

                    <span
                      className={`text-2xl font-bold mr-2 ${getOccupancyColor(
                        dashboardData?.occupancyPercentage || 0
                      )}`}
                    >
                      {dashboardData?.occupancyPercentage || "0"}
                    </span>

                    <span
                      // className={
                      //   dashboardData?.occupancyChange?.includes("-")
                      //     ? "arrow-down"
                      //     : "arrow-up"
                      // }
                      className={
                        isNegative(dashboardData?.occupancyChange)
                          ? "arrow-down"
                          : "arrow-up"
                      }
                    ></span>
                    <span
                      // className={`text-[12px] font-bold ml-2 ${
                      //   dashboardData?.occupancyChange?.includes("-")
                      //     ? "text-red-500"
                      //     : "text-green-atrium"
                      // }`}
                      className={`text-[12px] font-bold ml-2 ${
                        isNegative(dashboardData?.occupancyChange)
                          ? "text-red-500"
                          : "text-green-atrium"
                      }`}
                    >
                      {dashboardData?.occupancyChange || "0"} %
                    </span>
                  </p>
                </div>
                {/* <Link
              to="/admin/dashboard/occupancy"
              className="inline-block rounded-2xl bg-gray-50 dark:!bg-navy-700 p-[12px]"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.1665 10H15.8332M15.8332 10L9.99984 4.16669M15.8332 10L9.99984 15.8334"
                  stroke="#707EAE"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link> */}
              </div>

              <div className="flex-1 items-center rounded-[30px] p-[30px] gap-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
                <p className="text-sm text-gray-700">
                  Total Visitors (Monthly)
                </p>
                <p>
                  <span className="text-2xl font-bold mr-2">
                    {dashboardData?.totalCurrentMonthVisitors || "0"}
                  </span>
                  <span
                    // className={
                    //   dashboardData?.visitorChange?.includes("-")
                    //     ? "arrow-down"
                    //     : "arrow-up"
                    // }

                    className={
                      isNegative(dashboardData?.totalCurrentMonthVisitorsChange)
                        ? "arrow-down"
                        : "arrow-up"
                    }
                  ></span>
                  <span
                    // className={`text-[12px] font-bold ml-2 ${
                    //   dashboardData?.occupancyChange?.includes("-")
                    //     ? "text-red-500"
                    //     : "text-green-atrium"
                    // }`}
                    className={`text-[12px] font-bold ml-2 ${
                      isNegative(dashboardData?.totalCurrentMonthVisitorsChange)
                        ? "text-red-500"
                        : "text-green-atrium"
                    }`}
                  >
                    {/* {dashboardData?.totalCurrentMonthVisitorsChange || "0 %"} */}
                    {dashboardData?.totalCurrentMonthVisitorsChange || "0"} %
                  </span>
                </p>
              </div>
            </div>
          </div>
        </>
      )}

      <div className="flex flex-wrap gap-4 mt-4">
        <PredictedAttendance selectedCampusId={selectedCampusId} />
        <AttendancePeak selectedCampusId={selectedCampusId} />
      </div>

      <div className="flex flex-wrap gap-4 mt-4">
        <BusiestTime selectedCampusId={selectedCampusId} />
        <AverageVisitDuration selectedCampusId={selectedCampusId} />
      </div>
    </>
  );
};

export default AttendanceOverview;
